import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Alert,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Category } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import BannerImage from "../../component/admin/professionalTournaments/BannerImage";
import YoutubeLinksForm from "../../component/admin/formComponents/YoutubeLinksForm";
import moment from "moment";

const CustomTextarea = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    color: "black",
    padding: "10px 15px",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

export default function Goals() {
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      category: "default",
      link: "",
    },
    validationSchema: Yup.object().shape({
      category: Yup.number("Please enter integer value")
        .required("Category is Required")
        .typeError("Category is Required"),
      link: Yup.string().required("Link is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      // const data = new FormData();
      // data.append("category", values.category);
      // data.append("link", values.link);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/createLink`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(response.data.message);
          //   toast.success(test);
          navigate("/admin/dashboard/youtube-links");
        } else {
          toast.error(response.data.message);
        }
      } catch (e) {
        toast.error("error !!");
      } finally {
        setLoading(false);
      }
    },
  });


  return (
    <React.Fragment>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <Box className="free_votes_page">
        <Box className="page_title">
          <Typography variant="h1" component="h1">
            Add Youtube Link
          </Typography>
        </Box>

        <YoutubeLinksForm formik={formik} edited={false} />
      </Box>
    </React.Fragment>
  );
}
